import { useState, useEffect } from 'react';

import { getSearchCompatibleTagFromModelData } from 'services/helpers/search';

export default function useSubObjectiveState(initialSubObjective) {
  const [selectedSubObjective, setSelectedSubObjective] = useState(null);
  const subObjectiveColor = selectedSubObjective ? selectedSubObjective.color || 'textSecondary' : 'textSecondary';
  const subObjectiveIconColor = selectedSubObjective ? selectedSubObjective.color || 'textPrimary' : 'textPrimary';
  useEffect(() => {
    setSelectedSubObjective(getSearchCompatibleTagFromModelData(initialSubObjective));
  }, [JSON.stringify(initialSubObjective)]);
  return {
    selectedSubObjective,
    setSelectedSubObjective,
    subObjectiveColor,
    subObjectiveIconColor,
  };
}
